import React from 'react';
import { RichText, Elements } from 'prismic-reactjs';
import latinize from 'latinize';
import { navigate } from 'gatsby';
import { linkResolver, getLinkPropsFromData } from './link'

import { getDataLayer } from '../utils/gtm'
import { logData } from '../services/gtm'

export const RichLinks = (props) => {
	const { render, ...data } = props;

	if(render){
		return (
			<RichText render={render} htmlSerializer={(type, element, content, children, key) => linksSerializer(type, element, content, children, key, data)} />
		)
	}
	return null;
}

export const RichContent = ({render}) => {
	if(render){
		return (
			<RichText render={render} htmlSerializer={(type, element, content, children, key) => contentSerializer(type, element, content, children, key)} />
		)
	}
	return null;
}

const formatLabel = (label) => latinize(label).replace(/ /g,"_").toLowerCase()

// -- Function to add unique key to props
const propsWithUniqueKey = function(props, key) {
	return Object.assign(props || {}, { key });
};

const getLinkDataLayer = (linkData,pageData,label) => {
	let data = {};
	
	if(linkData.link_type === "Document"){
		data = {
			event: "link-" + (linkData.slug ? linkData.slug : linkData.type)
		}
	}
	else if(linkData.link_type){
		data = {
			event: "link-" + linkData.link_type.toLowerCase()
		}
	}

	return {
		...data,
		name: formatLabel(label),
		page: pageData.meta ? (pageData.meta.uid ? pageData.meta.uid : pageData.meta.type) : null
	}
}

export const linksSerializer = function(type, element, content, children, key, pageData) {
	var props = {};

	switch(type) {
		case Elements.listItem:
		case Elements.list:
		case Elements.paragraph:
			return children;
					
		case Elements.hyperlink:
			if(element.data.url === "https://chat"){
				props = Object.assign({
					onClick: () => {
						logData(getDataLayer(pageData,"chat"))
						if(window.__widget){
							window.__widget.open()
						}
					}
				})
				return React.createElement('span', propsWithUniqueKey(props, key), children);
			}

			const { as, ...linkProps } = getLinkPropsFromData(element.data);
			props = {...linkProps, onClick: (e) => {
				logData(getLinkDataLayer(element.data,pageData,content));
				
				if(props.to){
					e.preventDefault();
					navigate(props.to);
				}
			}}
			return React.createElement(as, propsWithUniqueKey(props, key), children);
		
		case Elements.span: // Span
			if (content) {
				return content.split("\n").reduce((acc, p) => {
					if (acc.length === 0) {
						return [p];
					} else {
						const brIndex = (acc.length + 1)/2 - 1;
						const br = React.createElement('br', propsWithUniqueKey({}, brIndex));
						return acc.concat([br, p]);
					}
				}, []);
			} else {
				return null;
			}

		default:
			return [];
	}
};

export const contentSerializer = function(type, element, content, children, key) {

	var props = {};

	switch(type) {
			
		case Elements.heading1: // Heading 1
			return React.createElement('h1', propsWithUniqueKey(props, key), children);
			
		case Elements.heading2: // Heading 2
			return React.createElement('h2', propsWithUniqueKey(props, key), children);
			
		case Elements.heading3: // Heading 3
			return React.createElement('h3', propsWithUniqueKey(props, key), children);
			
		case Elements.heading4: // Heading 4
			return React.createElement('h4', propsWithUniqueKey(props, key), children);
			
		case Elements.heading5: // Heading 5
			return React.createElement('h5', propsWithUniqueKey(props, key), children);
			
		case Elements.heading6: // Heading 6
			return React.createElement('h6', propsWithUniqueKey(props, key), children);
			
		case Elements.paragraph: // Paragraph
			if((content && content.length > 0) || (children && children.length > 0 && children[0])){
				return React.createElement('p', propsWithUniqueKey(props, key), children);
			}
			return [];
			
		case Elements.preformatted: // Preformatted
			return React.createElement('pre', propsWithUniqueKey(props, key), children);
			
		case Elements.strong: // Strong
			return React.createElement('strong', propsWithUniqueKey(props, key), children);
			
		case Elements.em: // Emphasis
			return React.createElement('em', propsWithUniqueKey(props, key), children);
			
		case Elements.listItem: // Unordered List Item
			return React.createElement('li', propsWithUniqueKey(props, key), children);
			
		case Elements.oListItem: // Ordered List Item
			return React.createElement('li', propsWithUniqueKey(props, key), children);
			
		case Elements.list: // Unordered List
			return React.createElement('ul', propsWithUniqueKey(props, key), children);
			
		case Elements.oList: // Ordered List
			return React.createElement('ol', propsWithUniqueKey(props, key), children);
			
		case Elements.hyperlink:
			if(element.data.url === "https://cookies"){
				props = Object.assign({
					onClick: () => {
						if(window.Cookiebot && window.Cookiebot.renew){
							window.Cookiebot.renew()
						}
					},
					className: "link"
				})
				return React.createElement('span', propsWithUniqueKey(props, key), children);
			}

			const { as, ...linkProps } = getLinkPropsFromData(element.data);
			props = {...linkProps}
			return React.createElement(as, propsWithUniqueKey(props, key), children);
		case Elements.label: // Label
			props = element.data ? Object.assign({}, { className: element.data.label }) : {};
			return React.createElement('span', propsWithUniqueKey(props, key), children);
			
		case Elements.span: // Span
			if (content) {
				return content.split("\n").reduce((acc, p) => {
					if (acc.length === 0) {
						return [p];
					} else {
						const brIndex = (acc.length + 1)/2 - 1;
						const br = React.createElement('br', propsWithUniqueKey({}, brIndex));
						return acc.concat([br, p]);
					}
				}, []);
			} else {
				return null;
			}

		default: // Always include a default that returns null
			return null;
	}
};